export const LANG_MAP = {
  'zh-CN':  { lang: 'zh-CN', header: 'zh-CN', label: '中文', flag: '🇨🇳' },
  'en-US':  { lang: 'en-US', header: 'en-US', label: 'English', flag: '🇺🇸' },
  'vi-VN':  { lang: 'vi-VN', header: 'vi-VN', label: 'Tiếng Việt', flag: '🇻🇳' }
}

export function getCurrentLocale() {
  var locale = localStorage.getItem('lang') || 'zh-CN'
  // 兼容旧格式
  if (locale === 'zhCN') return 'zh-CN'
  if (locale === 'en') return 'en-US'
  if (locale === 'zhVIE') return 'vi-VN'
  return locale
}

export function getBackendLang() {
  return getCurrentLocale()
}

export function getLanguageHeader() {
  return getCurrentLocale()
}

export function setLocale(locale) {
  localStorage.setItem('lang', locale)
}

export function getSupportedLanguages() {
  return Object.keys(LANG_MAP).map(function(key) {
    var val = LANG_MAP[key]
    return {
      key: key,
      lang: val.lang,
      header: val.header,
      label: val.label,
      flag: val.flag
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js